const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL;

export interface UserSettings {
  id?: number;
  userId?: number;
  timezone?: string;
  language?: string;
  theme?: 'light' | 'dark' | 'system';
  pushEnabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const getUserSettings = async (): Promise<UserSettings | null> => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/user/settings`, {
      method: 'GET',
      credentials: 'include',
    });

    if (!response.ok) {
      return null;
    }

    const settings = await response.json();
    return settings;
  } catch (error) {
    console.error('Failed to fetch user settings:', error);
    return null;
  }
};

export const updateUserSettings = async (
  settings: Partial<UserSettings>
): Promise<UserSettings | null> => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/user/settings`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(settings),
    });

    if (!response.ok) {
      return null;
    }

    const updated = await response.json();
    return updated;
  } catch (error) {
    console.error('Failed to update user settings:', error);
    return null;
  }
};

export const saveThemePreference = async (theme: 'light' | 'dark' | 'system') => {
  return updateUserSettings({ theme });
};
